// extracted by mini-css-extract-plugin
export default {"content":"nN18RBf","opacityIn":"zvOHOMT","type":"uLhGPx1","msg":"wg6acpC","close":"VM80nvZ","opacityOut":"xe1FHBM"};